<template>
  <div class="layout-inline-menu layout-inline-menu-action-panel" :class="{'layout-inline-menu-active': active}">

      <ul
          :class="['layout-inline-menu-action-panel']">
<!--        <li class="layout-inline-menu-action-item">-->
<!--          <a @click="incrementScale()" :disabled="scale === scales[scales.length - 1]" class="flex flex-row align-items-center">-->
<!--            <i class="pi pi-sort-alpha-up pi-fw"></i>-->
<!--            <span>Font increase</span>-->
<!--          </a>-->
<!--          <span class="layout-inline-menu-tooltip p-tooltip">-->
<!--					<span class="layout-inline-menu-tooltip-arrow p-tooltip-arrow"></span>-->
<!--					<span class="layout-inline-menu-tooltip-text p-tooltip-text">Font increase</span>-->
<!--				</span>-->
<!--        </li>-->
<!--        <li class="layout-inline-menu-action-item">-->
<!--          <a @click="decrementScale()" :disabled="scale === scales[0]" class="flex flex-row align-items-center">-->
<!--            <i class="pi pi-sort-alpha-down pi-fw"></i>-->
<!--            <span>Font diminish</span>-->
<!--          </a>-->
<!--          <span class="layout-inline-menu-tooltip p-tooltip">-->
<!--					<span class="layout-inline-menu-tooltip-arrow p-tooltip-arrow"></span>-->
<!--					<span class="layout-inline-menu-tooltip-text p-tooltip-text">Font diminish</span>-->
<!--				</span>-->
<!--        </li>-->
        <li class="layout-inline-menu-action-item">
          <a @click="logout()" class="flex flex-row align-items-center">
            <i class="pi pi-sign-out pi-fw"></i>
            <span>{{ $t('logout') }}</span>
          </a>
          <span class="layout-inline-menu-tooltip p-tooltip">
					<span class="layout-inline-menu-tooltip-arrow p-tooltip-arrow"></span>
					<span class="layout-inline-menu-tooltip-text p-tooltip-text">{{ $t('logout') }}</span>
				</span>
        </li>
      </ul>
  </div>

</template>

<script>
import store from "@/store";

export default {
  name: "AppInlineMenu",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    menuMode: String,
    inlineMenuKey: String
  },
  data(){
    return{

      scale: 14,
      scales: [12,13,14,15,16],
    }
  },
  methods: {
    onClick(event) {
      this.$emit('change-inlinemenu', !this.active, this.inlineMenuKey);
      event.preventDefault();
    },
    logout() {

      store.dispatch("logout").then(() => {
        console.log(21)
        window.location.reload();
      });
    },

    decrementScale() {
      if (this.scales.includes(this.scale)) {
        this.scale--;
        this.applyScale();
        this.$toast.add({severity: 'success', summary: 'Font', detail: 'Font diminished', life: 3000});
      }
    },
    incrementScale() {
      if (this.scales.includes(this.scale)){
        this.scale++;
        this.applyScale();
        this.$toast.add({ severity: 'success', summary: 'Font', detail: 'Font increased', life: 3000});
      }
    },
    applyScale() {
      document.documentElement.style.fontSize = this.scale + 'px';
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 991;
    },
    isRTL() {
      return this.$appState.RTL;
    }
  }
}
</script>

<style scoped>

</style>
